import React, { createContext, useContext, useState, ReactNode } from 'react';
import SubscriptionErrorModal from '../components/SubscriptionErrorModal';

interface SubscriptionErrorContextType {
  showSubscriptionError: (message?: string) => void;
  hideSubscriptionError: () => void;
  isSubscriptionErrorVisible: boolean;
}

const SubscriptionErrorContext = createContext<SubscriptionErrorContextType | undefined>(undefined);

interface SubscriptionErrorProviderProps {
  children: ReactNode;
}

export const SubscriptionErrorProvider: React.FC<SubscriptionErrorProviderProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const showSubscriptionError = (message?: string) => {
    setErrorMessage(message || '');
    setIsVisible(true);
  };

  const hideSubscriptionError = () => {
    setIsVisible(false);
    setErrorMessage('');
  };

  return (
    <SubscriptionErrorContext.Provider 
      value={{ 
        showSubscriptionError, 
        hideSubscriptionError, 
        isSubscriptionErrorVisible: isVisible 
      }}
    >
      {children}
      <SubscriptionErrorModal 
        isOpen={isVisible}
        onClose={hideSubscriptionError}
        message={errorMessage}
      />
    </SubscriptionErrorContext.Provider>
  );
};

export const useSubscriptionError = (): SubscriptionErrorContextType => {
  const context = useContext(SubscriptionErrorContext);
  if (!context) {
    throw new Error('useSubscriptionError must be used within a SubscriptionErrorProvider');
  }
  return context;
}; 